/* eslint-disable */

import OpeningTitleVideo from './Videos/opening-title.webm'
import ClosingTitleVideo from './Videos/closing-title.webm'
import UnrealWorldVideo from './Videos/unreal-world.webm'
import ChesmacVideo from './Videos/chesmac.webm'
import UunoTurhapuroVideo from './Videos/uuno-turhapuro.webm'
import MaxPayneVideo from './Videos/max-payne.webm'
import AngryBirdsVideo from './Videos/angrybirds.webm'
import SanxionVideo from './Videos/sanxion.webm'
import SlicksNSlideVideo from './Videos/slicks-n-slide.webm'
import SnakeVideo from './Videos/snake.webm'
import ClashOfClansVideo from './Videos/clash-of-clans.webm'

const SlidesEn = [
  {
    index: 0,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: OpeningTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  },
  {
    index: 1,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Chesmac (1979)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Created by Raimo Suonio as a project in his own spare time, the Chesmac chess game was Finland’s first-ever commercial computer game. In 1979, Suonio happened to be in between jobs and he developed Chesmac for his own amusement in a little over a month for the Telmac, a Finnish kit-built computer of the late 1970s that didn’t have much computing power. Although Suonio was not a professional game designer, he had the designer’s curiosity to see if the Telmac TMC-1800 could manage the operations needed in a game of chess. It did, very slowly, but still. A classic was born.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Chesmac was a piece of utopia in its day. A machine that could think strategically with its own artificial intelligence. Issued on C-cassette, Chesmac was also a commercial success. An astounding 104 of them were sold from Raimo Suonio’s new place of work, the Topdata firm. This was a respectable figure in Finland in the 1970s and 1980s. Ironically enough, Suonio, the designer of the game, still hasn’t become interested in chess.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Raimo Suonio',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Raimo Suonio / Topdata',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Telmac TMC-1800',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-cassette',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Problem-solving game / single player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ChesmacVideo
          },
        ]
      }
    }
  },
  {
    index: 2,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Sanxion (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Developed by Stavros Fasoulas (1968-), a pioneer of game design in Finland, Sanxion was one of the leading single player shooting games in the world. An exceptional feature of this game was its split screen allowing players to see their spaceship from above and the side. Sanxion was a challenging game mainly aimed at adults, requiring both dexterity and tactical skill. The audioscape of Sanxion was revolutionary at the time.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'When Sanxion was released in 1986, the legendary Finnish game journalist Niko Nirvi called its designer, Stavros Fasoulas, ‘the Paavo Nurmi of computer games’, with reference to Finland’s most famous long-distance runner. Sanxion’s electronic theme music created with SID technology by the renowned British game music composer Ron Hubbard (1956-) is an undisputed and universally remembered classic in the world of computer games. Originally Sanxion’s theme was based on Russian composer’s Sergey Prokofiev’s classic Dance of the Knights that was heard in Romeo And Juliet.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Stavros Fasoulas',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Thamalus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-cassette / diskette',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: shooting game / single player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SanxionVideo
          },
        ]
      }
    }
  },
  {
    index: 3,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Uuno Turhapuro muuttaa maalle (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Uuno Turhapuro muuttaa maalle (Uuno Turhapuro Moves to the Countryside) was programmed in a couple of months by video game designer Pasi Hytönen when he was still in high school. It was the first licensed digital game based on a Finnish film.  Expectations were high as the Uuno Turhapuro character played by actor Vesa-Matti Loiri was extremely popular in Finland in the 1980s. This was an action game of relatively high graphic standard where, instead of shooting, the action consists of ploughing, running in the forest and barefoot water-skiing. Programmed with sprite and ASCII graphics, Uuno is steered on vertical axis by the player. The programming language was Commodore’s own computer language. As a globally oriented character, Hytönen had copied his source code from foreign computer magazines.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Uuno Turhapuro muuttaa maalle is still remembered for its almost frustratingly high skill level requirements. Its designer was concerned that the film, which was light entertainment, might lead to a game that was too easy. It didn’t. According to one critic, the only ones who still play Uuno Turhapuro muuttaa maalle are sadists Over 2,000 copies of the game were sold in Finland.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Pasi Hytönen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Amersoft',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-cassette / diskette',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Action game / single player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UunoTurhapuroVideo
          },
        ]
      }
    }
  },
  {
    index: 4,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'UnReal World (1982)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Set in a fantasy world resembling prehistoric Finland, UnReal World is a survival game that will not necessarily end at all. It is the life’s work of Sami Maaranen, its other designer, and it has continued without interruption since 1982. The game is still updated at regular basis. UnReal World draws upon Finnish folk tales from the Iron Age (500 BC-1300 AD) and nature has a strong presence in it. Survival in the game calls for strength and ingenuity, and its core feature is realism. For example, the skin of the game characters can be damaged by frostbite.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'The characters in UnReal World include, among others, a fisherman and a hermit living amidst snowstorms and wild animals. The updates of UnReal World also take into account the real world, reflecting for example issues of climate change. In recent years, UnReal World has also attracted a great deal of international attention.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Sami Maaranen / Erkka Lehmus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Enormous Elk',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Windows / Mac OS X / Linux',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: C-cassette / diskette / now downloadable from the Internet',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Unending survival adventure / single player ',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UnrealWorldVideo
          },
        ]
      }
    }
  },
  {
    index: 5,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Slicks ‘n Slide (1993)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Slicks ’n’ Slide is a racing game designed by Timo and Juha Kauppinen, and a classic in its genre. The basic idea is simple: to drive a car faster than other players around a short circuit. Slicks ’n’ Slide was not graphically brilliant, but it provided in an exceptionally successful way the magic feeling often associated with motor racing. The game’s artificial intelligence was smart, but the most addictive feature of Slicks ’n’ Slide was that it could include four players. And yes, they all usually used the same keyboard. That’s what made it fun.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Slicks ’n’ Slide has an exceptionally wide range of vehicles, not only cars but also motorbikes, tanks and a UFOs, among others. Later versions have included various weapons as accessories. Slicks ’n’ Slide was participatory design, since the players could create their own racing circuits with the game’s track editor. The game is still available on the Internet.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Timo Kauppinen / Juha Kauppinen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Shareware free computer program',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: MS-DOS / Microsoft Windows',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Originally on diskette / now downloadable on the Internet',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Racing game / single player / multiplayer',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SlicksNSlideVideo
          },
        ]
      }
    }
  },
  {
    index: 6,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Snake (1997)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Nokia’s Snake was originally based on foreign classic games of the 1970s and it is probably better known around the world than any of Nokia’s mobile phones. This says everything about how globally popular the extremely simple but addictive Snake was in the late 1990s. In addition to the original Snake game, Nokia issued other, more developed, versions. But strange to say, none of them managed to achieve the hypnotic appeal of the original Snake.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Like many other iconic works in the history of design, Nokia’s original Snake game was created slightly by mistake. In 1997, Taneli Armanto, who was chosen to design it, was on the development team of the Nokia 6110 mobile phone and he was assumed to be a competent game designer. He was, however, mistaken for a younger relative of who had almost the same name, and more experience of designing games. Despite the mix-up, Taneli Armanto continued his development process by groping his way forward, creating as a result one of the most iconic games of popular culture.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Taneli Armanto',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Nokia',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Nokia 6110 and other Nokia mobile phones',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Mobile game',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Skill Game',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SnakeVideo
          },
        ]
      }
    }
  },
  {
    index: 7,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Max Payne (2001)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Created by Sami Järvi (1970-), Finland’s best-known game writer, Max Payne revolutionised the game business with its time-slowing bullet time technology. In terms of artificial intelligence and graphics Max Payne did not outrank other games, but its narrative was excellent. This was not a traditional shooting game, but an integrated story with a plot, sardonic dialogue and even a moral. Its film noir interludes in the style of comic book novels were also revolutionary. Max Payne was Finland’s first major-budget game and it led to world fame for its developer, Remedy.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Two sequels of Max Payne were released and it also became a Hollywood film. In the first part of the series, the actors of the game characters were Remedy employees and writer Sami Järvi lent his own face to the leading character. After Max Payne, Remedy went on to release Alan Wake (2010) and Quantum Break (2016), both of which have been international successes among critics and in numbers of sales.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Sami Järvi',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Remedy / Rockstar Games / Feral Interactive',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Microsoft Windows / PlayStation 2 / Xbox / Game Boy Advance / Macintosh',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: CD / DVD',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Third-person shooting game / single player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: MaxPayneVideo
          },
        ]
      }
    }
  },
  {
    index: 8,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Angry Birds (2009)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'With its fighting birds and pigs, Angry Birds is one of the most successful series of games in popular history. Why the whole world fell for this simple problem solving game is a mystery, but a positive one. According to one theory, Angry Birds was released at the time when the game preferences of consumers were moving on from computer and console games to mobile devices. Angry Birds made Rovio, the company that developed it, an international superstar and cemented the Finnish game industry’s world-leading status in its field.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'Angry Birds was the 52nd game created at Rovio. If it hadn’t succeeded, the future of the whole firm would have been at risk. An important factor for its breakthrough was the Lua programming language which made the game more fluid. There have been innumerable sequels in the Angry Birds series, as well as a full-length animated film. The birds’ humour still finds a response.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Jaakko Iisalo (Rovio)',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Clickgamer.com / Chillingo Ltd.',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: Various types of smartphones / tablets / game consoles',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Internet webstores / Blu-ray disc',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Problem solving game / single player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: AngryBirdsVideo
          },
        ]
      }
    }
  },
  {
    index: 9,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Clash of Clans (2012)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Story:'
            },
            {
              componentType: 'text',
              text: 'Clash of Clans will remain in world history as one of the most successful design products of all time. It phenomenal popularity is due to two factors. Firstly, its developer, Supercell, managed to attract people who had not been interested in mobile games before. Secondly, a considerable number of Clash of Clans players have been willing to buy extra related content for the game. Although the micro-sums that are involved are often insignificant for the individual player they combine into an immense amount of revenue. Like Rovio, Supercell succeeded where most designers fail – in commodifying their product.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Did you know that:'
            },
            {
              componentType: 'text',
              text: 'The basic idea of Clash of Clans is to build one’s own village, join a clan and expand ownership by attacking and taking over the villages of other players. Headed by Ilkka Paananen, Supercell is a prime example of how designers and businesses, if they so desire, can break out from their own genres and take an active part in social discussion and debate.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Lead Designer: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Released by: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Platform: iOS / Android',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Format: Mobile game',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Strategy game / multi player',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ClashOfClansVideo
          },
        ]
      }
    }
  },
  {
    index: 10,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: ClosingTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  }
]

export default SlidesEn



// WEBPACK FOOTER //
// ./src/SlidesEn.js